<template>
  <div id="ai-chatbots">
    <v-card class="section-card">
      <v-card-title :class="{ 'mobile-card-title': isMobile }">{{ $t('aiChatbotsTitle') }}</v-card-title>
      <p :class="{ 'mobile-card-subheading': isMobile }">{{ $t('aiChatbotsSubheading') }}</p>

      <v-card-text style="padding: 0">
        <p :class="['section-text', { 'mobile-card-text': isMobile }]">{{ $t('aiChatbotsText') }}</p>

        <div class="use-cases-grid">
          <v-card class="use-case-card">
            <div class="use-case-icon">
              <v-icon size="40" color="white">mdi-face-agent</v-icon>
            </div>
            <h3 class="use-case-title">{{ $t('aiUseCaseSupportTitle') }}</h3>
            <p class="use-case-desc">{{ $t('aiUseCaseSupportText') }}</p>
          </v-card>

          <v-card class="use-case-card">
            <div class="use-case-icon">
              <v-icon size="40" color="white">mdi-file-document-edit-outline</v-icon>
            </div>
            <h3 class="use-case-title">{{ $t('aiUseCaseQuotesTitle') }}</h3>
            <p class="use-case-desc">{{ $t('aiUseCaseQuotesText') }}</p>
          </v-card>

          <v-card class="use-case-card">
            <div class="use-case-icon">
              <v-icon size="40" color="white">mdi-database-search</v-icon>
            </div>
            <h3 class="use-case-title">{{ $t('aiUseCaseDataTitle') }}</h3>
            <p class="use-case-desc">{{ $t('aiUseCaseDataText') }}</p>
          </v-card>
        </div>

        <div class="security-banner">
          <v-icon size="28" color="white" class="mr-3">mdi-shield-check</v-icon>
          <div>
            <h4 class="security-title">{{ $t('aiSecurityTitle') }}</h4>
            <p class="security-text">{{ $t('aiSecurityText') }}</p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AiChatbots",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.section-card {
  margin: 10px !important;
  padding: 20px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  background: linear-gradient(90deg, #03000f, #3533cd) !important;
  color: #ffffff !important;
  border-radius: 25px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.section-text {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.use-cases-grid {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.use-case-card {
  flex: 1 1 280px;
  background: transparent !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px !important;
  padding: 2rem !important;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.use-case-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.use-case-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: white;
}

.use-case-desc {
  font-size: 0.95rem;
  line-height: 1.5;
  opacity: 0.9;
  color: white;
}

.security-banner {
  display: flex;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  padding: 1.5rem;
  gap: 1rem;
}

.security-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: white;
  margin-bottom: 0.25rem;
}

.security-text {
  font-size: 0.95rem;
  color: white;
  opacity: 0.9;
  line-height: 1.5;
}

.mobile-card-title {
  font-size: 1.5rem;
}

.mobile-card-subheading {
  font-size: 1rem;
}

.mobile-card-text {
  font-size: 0.9rem;
}
</style>
